module.exports = __webpack_public_path__ + "img/pro_seven_2.a99b9195.jpg";